var map = {
	"./cloud.jpg": 243,
	"./kubernetes.jpg": 545,
	"./mongodb.jpg": 870,
	"./mysql.jpg": 240,
	"./nodejs.jpg": 376,
	"./python.jpg": 139,
	"./react.jpg": 792,
	"./saas.jpg": 588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;